import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { Box, LinearProgress, Typography, Tab, Grid, 
// Select,
// MenuItem,
Button, Stack, } from '@mui/material';
import { 
// navStore,
useStore, useTokens, } from '@mcn-platform/models';
import { orderBy } from 'lodash-es';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import CourseProgressCard from './CourseProgressCard';
import LearningBoardWidget from '../myAccount/LearningBoardWidget';
import AccountDialogs from '../nav/AccountDialogs';
import TableList from '../myAccount/TableList';
import MyDocuments from '../document/MyDocuments';
import MyResults from '../results/MyResults';
// const listCertificationNames = observer(({ value }:{ value: any }) => (
//   <span>
//     Certification
//     {value?.toString()}
//   </span>
// ));
const listCertificationNamesFormatter = (value) => {
    if (!value) {
        return '-';
    }
    return value.map((certification) => (certification.name)).join();
};
const courseNameFormatter = (value) => {
    if (!value) {
        return '-';
    }
    return value.name;
};
const titleField = {
    name: 'course',
    label: 'Course',
    formatter: courseNameFormatter,
};
const certificationSecondaryFields = [
    {
        name: 'completedCertifications',
        label: 'Certification Name',
        formatter: listCertificationNamesFormatter,
    },
    { name: 'createdAt', label: 'Date of certification' },
    { name: 'download', label: '' },
];
const limitToPageWidth = true;
const LinearProgressWithLabel = ({ value }) => (_jsxs(Box, { sx: { display: 'flex', alignItems: 'center' }, children: [_jsx(Box, { sx: { width: '100%', mr: 1 }, children: _jsx(LinearProgress, { variant: "determinate", sx: { height: 12 }, value: value }) }), _jsx(Box, { sx: { minWidth: 35 }, children: _jsx(Typography, { variant: "body2", color: "text.primary", children: `${Math.round(value)}%` }) })] }));
const ItemList = ({ progressList, viewAction, showProgressBars }) => {
    if (!progressList.length) {
        return (_jsx(Box, { sx: { textAlign: 'center' }, children: _jsx(Typography, { variant: "h5", color: "text.primary", children: "No learnings found." }) }));
    }
    return (_jsx(Grid, { container: true, spacing: 2, alignContent: "center", justifyContent: "left", children: (progressList).map((progress) => (_jsxs(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3, xl: 2, sx: {
                minWidth: '275px',
            }, children: [_jsx(CourseProgressCard, { item: progress.getItem(), viewAction: viewAction }), showProgressBars && progress.getItem()?.syncState === 'loaded' && (_jsx(LinearProgressWithLabel, { value: typeof progress.progress === 'number' ? progress.progress : 0 }))] }, progress.id))) }));
};
// eslint-1disable-next-line @typescript-eslint/no-unused-vars
const MyLearnings = ({ viewAction, showProgressBars }) => {
    const { isAnonymous, currentCourseProgresses: courseProgressList, currentMicrocastProgresses: microcastProgressList, currentProgramProgresses: programProgressList, currentLearningBoard: learningBoard, currentPortal, getSignedCertificateUrl, } = useStore();
    const { showCertification, showQuizResultsTab } = currentPortal;
    const tokens = useTokens();
    const [selectedItem] = useState('any');
    const [tabValue, setTabValue] = useState('allCourses');
    const [certifications, setCertifications] = useState([]);
    const tabs = [
        { id: 'allCourses', text: 'All' },
        { id: 'currentlyWatching', text: 'In Process' },
        { id: 'completedCourses', text: 'Completed' },
    ];
    if (showCertification) {
        tabs.push({ id: 'myCertification', text: 'Certifications' });
    }
    if (showQuizResultsTab) {
        tabs.push({ id: 'myResults', text: tokens.getToken('myResultsLabel') });
    }
    // const items = [
    //   { modelName: 'any', label: 'Any' },
    //   { modelName: 'course', label: 'Courses' },
    //   { modelName: 'program', label: 'Programs' },
    //   { modelName: 'microcast', label: 'Microcasts' },
    // ];
    const getTabs = () => ([
        ...tabs,
        ...(learningBoard && learningBoard.syncState === 'loaded'
            ? [{ id: 'myLearningBoard', text: tokens.getToken('myLearningBoardLabel') }]
            : []),
        { id: 'myDocuments', text: tokens.getToken('myDocumentsLabel') },
    ]);
    // const handleItemChange = (e: any) => {
    //   setSelectedItem(e.target.value as string);
    // };
    const getProgressList = () => {
        switch (selectedItem) {
            case 'any':
                return orderBy(courseProgressList
                    .concat(programProgressList)
                    .concat(microcastProgressList), ['updatedAt'], ['desc']);
            case 'program':
                return programProgressList;
            case 'microcast':
                return microcastProgressList;
            default: // course
                return courseProgressList;
        }
    };
    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };
    const downloadCertificate = (progress) => {
        // get the link and then open in a new window
        const certificate = progress.certificates[0];
        console.log('Download', certificate);
        const certWindow = window.open('', '_blank');
        certWindow?.document.write('Generating certificate. Please wait...');
        const getCertificate = async () => {
            try {
                const certificateUrl = await getSignedCertificateUrl(certificate.id);
                certWindow.location.href = certificateUrl;
            }
            catch (exception) {
                console.log('error downloading certificate', exception);
                certWindow.document.write('We\'re sorry, there was an error generating the certificate.');
            }
        };
        getCertificate();
    };
    const getCertifications = useCallback(() => {
        // TO DO get certificate list
        console.log('getCertificateList: ', courseProgressList);
        const certificateProgresses = courseProgressList.filter((courseProgress) => (courseProgress.certificates?.length > 0));
        return certificateProgresses;
    }, [courseProgressList]);
    useEffect(() => {
        setCertifications(getCertifications());
    }, [getCertifications, courseProgressList?.length]);
    const [showDialog, setShowDialog] = useState();
    if (isAnonymous) {
        return (_jsxs(Box, { sx: {
                m: 2,
                px: 4,
                ...(limitToPageWidth && {
                    width: '100%',
                    maxWidth: 1200,
                    marginX: 'auto',
                }),
            }, children: [_jsxs(Typography, { variant: "h4", children: ["To get access to", ' ', tokens.getToken('myLearningsLabel'), ", please either", _jsx(Button, { onClick: () => setShowDialog('SIGN-IN'), sx: { textTransform: 'none', fontSize: 'inherit', verticalAlign: 'baseline' }, children: "sign in" }), "or", _jsx(Button, { onClick: () => setShowDialog('SIGN-UP'), sx: { textTransform: 'none', fontSize: 'inherit', verticalAlign: 'baseline' }, children: "create an account." })] }), _jsx(AccountDialogs, { showDialog: showDialog, setShowDialog: setShowDialog, handleClose: () => setShowDialog(undefined) })] }));
    }
    return (_jsxs(Box, { sx: {
            m: 2,
            px: 4,
            ...(limitToPageWidth && {
                width: '100%',
                maxWidth: 1200,
                marginX: 'auto',
            }),
        }, children: [_jsx(Typography, { className: "systemPageTitle", children: tokens.getToken('myLearningsLabel') }), _jsx(Box, { sx: { width: '100%', typography: 'body1' }, children: _jsxs(TabContext, { value: tabValue, children: [_jsx(Stack, { direction: "row", sx: { borderBottom: 1, borderColor: 'divider' }, justifyContent: "space-between", alignItems: "center", children: _jsx(TabList, { onChange: handleChange, "aria-label": "tabs", textColor: "inherit", variant: "scrollable", scrollButtons: "auto", children: getTabs().map((tab) => (_jsx(Tab, { value: tab.id, label: tab.text, sx: {
                                        borderBottom: 0,
                                        p: 0,
                                        mx: 2,
                                        my: 1.5,
                                        minWidth: '50px',
                                        minHeight: '25px',
                                        '&.Mui-selected': {
                                            borderBottom: 1,
                                            borderColor: 'contract.main',
                                        },
                                    } }, tab.id))) }) }), _jsx(TabPanel, { value: "allCourses", children: _jsx(ItemList, { progressList: getProgressList(), viewAction: viewAction, showProgressBars: showProgressBars }) }), _jsx(TabPanel, { value: "currentlyWatching", children: _jsx(ItemList, { progressList: getProgressList().filter((courseProgress) => (courseProgress.progress > 0 && courseProgress.progress <= 99)), viewAction: viewAction, showProgressBars: showProgressBars }) }), _jsx(TabPanel, { value: "completedCourses", children: _jsx(ItemList, { progressList: getProgressList().filter((courseProgress) => (courseProgress.progress > 99)), viewAction: viewAction, showProgressBars: showProgressBars }) }), _jsx(TabPanel, { value: "myLearningBoard", children: _jsx(LearningBoardWidget, { configId: "myLearningsPage" }) }), _jsxs(TabPanel, { value: "myCertification", children: [certifications.length !== 0 && (_jsx(TableList, { items: certifications, titleField: titleField, secondaryFields: certificationSecondaryFields, showSelect: false, handleSelectAll: () => true, handleSelectOne: () => true, selectedIDs: [], actions: [
                                        {
                                            label: 'Download',
                                            default: true,
                                            action: downloadCertificate,
                                        },
                                    ] })), certifications.length === 0 && (_jsx(Box, { sx: { textAlign: 'center' }, children: _jsx(Typography, { variant: "h5", color: "text.primary", children: "There are no certifications for this user at this time." }) }))] }), _jsx(TabPanel, { value: "myDocuments", children: _jsx(MyDocuments, {}) }), _jsx(TabPanel, { value: "myResults", children: _jsx(MyResults, {}) })] }) })] }));
};
MyLearnings.defaultProps = {
    viewAction: undefined,
    showProgressBars: true,
};
MyLearnings.meta = {
    name: 'My Learnings Panel',
    group: 'account',
    description: 'Displays the learning progress.',
    props: [
        {
            key: 'showProgressBars',
            name: 'Show Progress Bars',
            type: 'boolean',
            description: 'Show the progress bar on the bottom of card',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'MyLearnings',
        props: {
            viewAction: undefined,
            showProgressBars: true,
        },
    },
};
export default observer(MyLearnings);
//# sourceMappingURL=MyLearnings.js.map